import { render, staticRenderFns } from "./LandingTierGroupCard.vue?vue&type=template&id=3b71416a&scoped=true&"
import script from "./LandingTierGroupCard.vue?vue&type=script&lang=js&"
export * from "./LandingTierGroupCard.vue?vue&type=script&lang=js&"
import style0 from "./LandingTierGroupCard.vue?vue&type=style&index=0&id=3b71416a&lang=scss&scoped=true&"
import style1 from "./LandingTierGroupCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b71416a",
  null
  
)

export default component.exports